// extracted by mini-css-extract-plugin
export default {"FCoverImage":"FCoverImage___wVajy"};